export { default as PushpinSolidIcon } from './PushpinSolidIcon';
